const globalLang = {
  subscribeLegal: {
    en: 'I consent to receive email and other electronic communications with information, promotions and offers about products and services from Mazda Canada Inc.(<a href="https://www.mazda.ca/en/about/contact-us/" className="mz-link">CONTACT US</a>) and its <a href="https://www.mazda.ca/en/shopping-tools/find-a-dealer/" className="mz-link">DEALERS</a> that are relevant to my interests based on information Mazda has about me. Consent is sought by Mazda for itself and its dealers. I may unsubscribe at any time. I also consent for Mazda to use my information in accordance with its <a href="https://www.mazda.ca/en/privacy/" className="mz-link">PRIVACY POLICY</a>.',
    fr: 'Je consens à recevoir des courriels et autres communications électroniques contenant de l’information, des promotions et des offres sur les produits et services de Mazda Canada inc. (<a href="https://www.mazda.ca/fr/a-propos/contactez-nous/" className="mz-link">CONTACTEZ-NOUS</a>) et de ses <a href="https://www.mazda.ca/fr/outils-dachat/trouver-un-concessionnaire/" className="mz-link">CONCESSIONNAIRES</a>, qui correspondent à mes intérêts en fonction des données que Mazda possède à mon sujet. Mon consentement est demandé par Mazda pour elle-même et ses concessionnaires. Je pourrai me désabonner à tout moment. Je consens également à ce que Mazda utilise mes renseignements personnels conformément à sa <a href="https://www.mazda.ca/fr/politique-de-confidentialite/" className="mz-link">POLITIQUE DE CONFIDENTIALITÉ</a>.'
  },
  emailEncouragement: {
    en: 'Keep up to date on the latest Mazda news from Canada and around the world. Receive our monthly newsletter, be the first to hear about new technology, innovations, new vehicles releases, and a whole lot more.',
    fr: 'Keep up to date on the latest Mazda news from Canada and around the world. Receive our monthly newsletter, be the first to hear about new technology, innovations, new vehicles releases, and a whole lot more. (FR)',
  },
  or: {
    en: 'or',
    fr: 'ou'
  },
  findDealerSub: {
    en: 'Find the dealership closest to you',
    fr: 'Find the dealership closest to you (FR)'
  },
  selectVehicle: {
    en: 'Select a vehicle',
    fr: 'Select a vehicle (FR)'
  },
  selectDealer: {
    en: 'Select this dealership',
    fr: 'Select this dealership (FR)'
  },
  selectDateAndTime: {
    en: 'Select your date and time',
    fr: 'Select your date and time (FR)'
  },
  fillContactForm: {
    en: 'Please fill out your contact details',
    fr: 'Please fill out your contact details (FR)'
  },
  unavailableInRegion: {
    en: 'Unavailable in your region',
    fr: 'Unavailable in your region (FR)'
  },
  previous: {
    en: 'Previous',
    fr: 'Previous (FR)',
  },
  from: {
    en: 'From',
    fr: 'From (FR)',
  },
  startingFrom: {
    en: 'Starting from',
    fr: 'Starting from (FR)',
  },
  morning: {
    en: 'morning',
    fr: 'morning (FR)',
  },
  afternoon: {
    en: 'afternoon',
    fr: 'afternoon (FR)',
  },
  evening: {
    en: 'evening',
    fr: 'evening (FR)',
  },
  continue: {
    en: 'continue',
    fr: 'continue (FR)',
  },
  requiredFields: {
    en: 'Required Fields',
    fr: 'Required Fields (FR)',
  },
  date: {
    en: 'Date',
    fr: 'Date (FR)',
  },
  timePreference: {
    en: 'Time Preference',
    fr: 'Time Preference (FR)',
  },
  dealerWebsite: {
    en: 'Visit Website',
    fr: 'Visiter le site web',
  },
  dealerDirections: {
    en: 'Get Directions',
    fr: 'Obtenir un itinéraire',
  },
  drag360: {
    en: 'Drag to view',
    fr: 'Drag to view (FR)',
  },
  selectDealerNav: {
    en: 'Select a dealer',
    fr: 'Select a dealer (FR)',
  },
  selectDateAndTimeNav: {
    en: 'Date and time',
    fr: 'Date and time (FR)',
  },
  contactDetailsNav: {
    en: 'Contact details',
    fr: 'Contact details (FR)',
  },
  step: {
    en: 'STEP',
    fr: 'STEP (FR)',
  },
  vehicles: {
    en: 'Vehicles',
    fr: 'Vehicles (FR)',
  },
  change: {
    en: 'Change',
    fr: 'Change (FR)',
  },
  noResults: {
    en: 'No results found.',
    fr: 'No results found. (fr)'
  },
  httpResponseError: {
    en: 'Error: Request failed with status code',
    fr: 'Error: Request failed with status code (fr)'
  },
  learnMore: {
    en: 'Learn More',
    fr: 'Learn More (FR)',
  },
  asOf: {
    en: 'As of',
    fr: 'As of (FR)',
  },
  buildAndPrice: {
    en: 'Build and price',
    fr: 'Build and price (FR)',
  },
  odometer: {
    en: 'Odometer',
    fr: 'Odometer (FR)',
  },
  vin: {
    en: 'VIN',
    fr: 'VIN (FR)',
  },
}

export default globalLang;